import React from "react";
import TableFourA from "./Components/StudentPerformance/TableFourA";
import TableFourB from "./Components/StudentPerformance/TableFourB";
import TableFourC from "./Components/StudentPerformance/TableFourC";
import TableFour1 from "./Components/StudentPerformance/TableFour1";
import TableFour2 from "./Components/StudentPerformance/TableFour2";
import TableFour3 from "./Components/StudentPerformance/TableFour3";
import TableFour4 from "./Components/StudentPerformance/TableFour4";
import TableFour5 from "./Components/StudentPerformance/TableFour5";
import TableFour6 from "./Components/StudentPerformance/TableFour6";

const API = "https://nba-backend.herokuapp.com";

const StudentPerformancePage = () => {
  return (
    <div style={{ padding: 10 }}>
      <h1> Criterion 4 - Students' Performance </h1>
      <TableFourA API={API} />
      <TableFourB API={API} />
      <TableFourC API={API} />
      <TableFour1 API={API} />
      <TableFour2 API={API} />
      <TableFour3 API={API} />
      <TableFour4 API={API} />
      <TableFour5 API={API} />
      <TableFour6 API={API} />
    </div>
  );
};

export default StudentPerformancePage;
